import * as google_protobuf_wrappers_pb from 'google-protobuf/google/protobuf/wrappers_pb'
import * as timestamp_pb from 'google-protobuf/google/protobuf/timestamp_pb'

export default {

  int64(number) {
    const pb = new google_protobuf_wrappers_pb.Int64Value()
    pb.setValue(number)
    return pb
  },
  //
  // int32(v: number): google_protobuf_wrappers_pb.Int32Value {
  //   const pb = new google_protobuf_wrappers_pb.Int32Value();
  //   pb.setValue(v);
  //   return pb;
  // }
  //
  string(string) {
    const pb = new google_protobuf_wrappers_pb.StringValue()
    pb.setValue(string)
    return pb
  },

  //
  boolean(boolean) {
    const pb = new google_protobuf_wrappers_pb.BoolValue()
    pb.setValue(boolean)
    return pb
  },
  //
  // bytes(v: Uint8Array): google_protobuf_wrappers_pb.BytesValue {
  //   const pb = new google_protobuf_wrappers_pb.BytesValue();
  //   pb.setValue(v);
  //   return pb;
  // }
  //
  // double(v: number): google_protobuf_wrappers_pb.DoubleValue {
  //   const pb = new google_protobuf_wrappers_pb.DoubleValue();
  //   pb.setValue(v);
  //   return pb;
  // }
  //
  // float(v: number): google_protobuf_wrappers_pb.FloatValue {
  //   const pb = new google_protobuf_wrappers_pb.FloatValue();
  //   pb.setValue(v);
  //   return pb;
  // }
  //
  uint32(number) {
    const pb = new google_protobuf_wrappers_pb.UInt32Value();
    pb.setValue(number);
    return pb;
  },
  //
  // uint64(v: number): google_protobuf_wrappers_pb.UInt64Value {
  //   const pb = new google_protobuf_wrappers_pb.UInt64Value();
  //   pb.setValue(v);
  //   return pb;
  // }
  timestamp(string) {
    const Timestamp = new timestamp_pb.Timestamp()
    Timestamp.setSeconds(new Date(Date.parse(string)).getTime() / 1000)
    return Timestamp;
  }

}
